import { render, staticRenderFns } from "./MobileBanner.vue?vue&type=template&id=6c31943d&scoped=true&"
import script from "./MobileBanner.vue?vue&type=script&lang=js&"
export * from "./MobileBanner.vue?vue&type=script&lang=js&"
import style0 from "./MobileBanner.vue?vue&type=style&index=0&id=6c31943d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c31943d",
  null
  
)

export default component.exports